// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".speakers_preview_module .speaker_preview_title{margin-bottom:32px}", "",{"version":3,"sources":["webpack://./src/ui/modules/SpeakersPreviewModule/style.scss"],"names":[],"mappings":"AACE,gDACE,kBAAA","sourcesContent":[".speakers_preview_module {\n  .speaker_preview_title {\n    margin-bottom: 32px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
